import React from 'react';
import '../../styles/Footer.css';
//import footerLogo from '../../assets/TP-logo.png'
import footerLogo from '../../assets/image/logo1.png';
import TimelineGr from '../../assets/documents/Timeline_GR.pdf';
import Charges_GR from '../../assets/documents/Charges_GR.pdf';
import RTS from '../../assets/documents/RTS.pdf';
const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <img src={footerLogo} alt="DTP Logo" className="footer-logo" />
          <a href='https://dtp.maharashtra.gov.in'><h3>Town Planning Department</h3></a>
        </div>

        <div className="footer-section">
          <h4>Follow us on</h4>
          <div className="social-links">
            <a href="#" className="social-link">
              <i className="fab fa-facebook"></i>
              Facebook
            </a>
            <a href="#" className="social-link">
              <i className="fab fa-twitter"></i>
              Twitter
            </a>
            <a href="#" className="social-link">
              <i className="fab fa-youtube"></i>
              Youtube
            </a>
            <a href="#" className="social-link">
              <i className="fab fa-instagram"></i>
              Instagram
            </a>
          </div>
        </div>
 {/* 
        <div className="footer-section">
          <h4>QUICK LINKS</h4>
          <ul className="footer-links">
            <li><a href="#">Zone Certificate & Part Plan Certificate</a></li>
            <li><a href="#">Pradhan Mantri Awas Yojana(Rural)</a></li>
            <li><a href="#">Apple Sarkar</a></li>
            <li><a href="#">Right to Services (RTS)</a></li>
            <li><a href="#">Centralized Public Grievance Redress And Monitoring System (CPGRAMS)</a></li>
            <li><a href="#">Government of Maharashtra</a></li>
            <li><a href="#">Collector of Pune</a></li> 
            <li><a href="#">Pune Municipal Corporation (PMC)</a></li>
            <li><a href="#">Pimpri-Chinchwad Municipal Corporation (PCMC)</a></li>
            <li><a href="#">eTapal & File Tracking System (eTapal & FTS)</a></li>
            <li><a href="#">Intelligent Works Management System (IWMS)</a></li>
            <li><a href="#">Pradhan Mantri Away Yojana-PMRDA(Urban)</a></li>
            <li><a href="#">Suggestions/Objections</a></li>
            <li><a href="#">DP of PMR (2021-2041)</a></li>
          </ul>
        </div>
*/}
        <div className="footer-section">
          <h4>QUICK LINKS</h4>
          <ul className="footer-links">
            <li><a href="#">Zone Certificate Application</a></li>
            <li><a href="#">Part Plan Application</a></li>
            <li><a href="https://aaplesarkar.mahaonline.gov.in/en">Apple Sarkar</a></li>

            <li><a href="#">User Manual / Help</a></li>
            <li><a href="#">Feedback / Suggestions</a></li>
            <li><a href={RTS}>RTS - Right to Services</a></li>
            <li><a href="https://www.maharashtra.gov.in/">Government of Maharashtra</a></li>
            <li><a href="https://dtp.maharashtra.gov.in/">Town Planning & Valuation Department</a></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>LEGAL</h4>
          <ul className="footer-links">
            <li><a href={TimelineGr}>Timeline GR</a></li>
            <li><a href="#">Website Content Contribution, Moderation & Approval Policy (CMAP)</a></li>
            <li><a href="#">Content Archival (CAP) policy</a></li>
            <li><a href={Charges_GR}>Charges GR</a></li>
            <li><a href="#">Hyperlink Policies</a></li>
            <li><a href="#">Privacy Policies</a></li>
            <li><a href="#">Terms & Conditions</a></li>
            <li><a href="#">Website Monitoring Plan</a></li> 
            <li><a href="#">Disclaimer</a></li>
          </ul>
        </div>

        <div className="footer-section">
          {/* 
          <h4>ACCESSIBILITY</h4>
          <ul className="footer-links">
            <li><a href="#">SiteMap</a></li>
            <li><a href="#">Accessibility</a></li>
            <li><a href="#">Help</a></li>
          </ul>
          */}
          <h4 className="contact-heading">CONTACT US</h4>
          <ul className="footer-links">
            <li><a href="#">Contact Us</a></li>
            <li><a href="#">Feedback</a></li>
            <li><a href="#">Enquiry</a></li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© 2025 Town Planning Department. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer; 